import React from "react";
import GameInstructionModal from "../GameInstructionModal";

const BlueRedRapidMovementModal = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Rapid Movement (Red/Blue)"
      gamePath="/userDashboard/game/red-and-blue-rapidmovement"
      icon="solar:bolt-bold"
      instructions={[
        "Wear red and blue glasses.",
        "Rapidly press the corresponding letter on your keyboard that matches the flashing letter on the screen."
      ]}
      isBinocular={true}
    />
  );
};

export default BlueRedRapidMovementModal;
